import { render, staticRenderFns } from "./2200_Key_Takeaways_and_Recap.vue?vue&type=template&id=1db9c4d6&scoped=true&lang=pug"
var script = {}
import style0 from "./2200_Key_Takeaways_and_Recap.vue?vue&type=style&index=0&id=1db9c4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db9c4d6",
  null
  
)

export default component.exports